(function() {
  'use strict';
  
  let moved = false;
  
  function moveProductSamples() {
    if (moved) return;
    
    // Flexibele selector - zoek op button attribuut ipv exacte ID
    const sampleButton = document.querySelector('button[product-samples-button]');
    if (!sampleButton) return;
    
    // Vind het app block (overgrootouder van de button)
    const appBlock = sampleButton.closest('.shopify-app-block');
    const hulkDiscountTable = document.querySelector('.hulkapps-volume-discount-tiers');
    
    if (!appBlock || !hulkDiscountTable) return;
    
    // Verberg beide elementen tijdens verplaatsing
    appBlock.style.visibility = 'hidden';
    hulkDiscountTable.style.visibility = 'hidden';
    
    const oldParent = appBlock.closest('.product-info__block');
    const newWrapper = document.createElement('div');
    newWrapper.className = 'product-info__block';
    
    newWrapper.appendChild(appBlock);
    hulkDiscountTable.insertAdjacentElement('beforebegin', newWrapper);
    
    if (oldParent && oldParent.children.length === 0) {
      oldParent.remove();
    }
    
    moved = true;
    
    // Maak beide weer zichtbaar
    requestAnimationFrame(() => {
      appBlock.style.visibility = 'visible';
      hulkDiscountTable.style.visibility = 'visible';
    });
    
    console.log('✓ Product samples verplaatst boven Hulk table');
  }
  
  // Probeer meteen
  moveProductSamples();
  
  // Observer voor als elementen later laden
  const observer = new MutationObserver(moveProductSamples);
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Stop observer na 3 seconden
  setTimeout(() => observer.disconnect(), 3000);
})();
